import { OpeningHour } from '../Landing/types'
import capitalize from 'lodash/capitalize'
import { format, parse } from 'date-fns'
import { CategoryProduct } from '../Shop/Categories'

export const createOpeningHours = (schedule: OpeningHour[]) => {
  if (!schedule.length) return []

  return schedule
    .flatMap((openingTime: OpeningHour) => {
      const { dayOfWeek, shifts } = openingTime
      if (!shifts.length) return []

      const dayOfWeekCapitalized = capitalize(dayOfWeek)

      return shifts.map((shift) => {
        const startTime = appendSeconds(shift.startTime)
        const endTime = appendSeconds(shift.endTime)
        return {
          '@type': 'OpeningHoursSpecification' as const,
          dayOfWeek: dayOfWeekCapitalized,
          opens: startTime,
          closes: endTime
        }
      })
    })
    .filter(Boolean)
}

const appendSeconds = (time: string): string => {
  return format(parse(time, 'HH:mm', new Date()), 'HH:mm:ss')
}

/** Temp: Created to handle the difference between two product types, will be removed in https://slerpy.atlassian.net/browse/CHK-2169 */
export const createOffers = (
  product: CategoryProduct,
  organization: string,
  url: string
) => {
  if (product.variants.length) {
    return product.variants.map((variant) =>
      buildOffer(
        variant.id,
        variant.name,
        variant.inStock,
        variant.pricing.absolute.base,
        url,
        organization
      )
    )
  }

  return [
    buildOffer(
      product.defaultVariantId,
      product.name,
      product.inStock,
      product.pricing.minimum.base,
      url,
      organization
    )
  ]
}

const buildOffer = (
  id: string,
  name: string,
  inStock: boolean,
  price: string,
  url: string,
  organization: string
) => {
  return {
    '@type': 'Offer' as const,
    sku: id,
    name: name,
    availability: inStock
      ? 'http://schema.org/InStock'
      : 'http://schema.org/OutOfStock',
    price: price,
    priceCurrency: 'GBP',
    url: url,
    seller: {
      '@type': 'Organization',
      name: organization
    }
  }
}

export const trimUrl = (url: string) => {
  return url.replace(/\/+$/, '')
}
